import { useState, useEffect } from 'react';
import { FlightEntity } from '@src/features/order/entities';
import { PreviousFlights } from '@src/features/drone/pages/drones-page/maps/drones/types';
import { getBearing } from '@src/features/drone/utils';

/**
 * Hook to manage drone rotations and previous flight positions
 * Uses heading from flightData if available, otherwise uses previous bearing or calculates new one
 * 
 * @param flightData - Current flight data from WebSocket (may be null/undefined)
 * @returns Object containing rotations map (serialNumber -> angle) and previousFlights map
 */
export const useDroneRotations = (
  flightData: FlightEntity | undefined | null
): { rotations: Record<string, number>; previousFlights: PreviousFlights } => {
  const [rotations, setRotations] = useState<Record<string, number>>({});
  const [previousFlights, setPreviousFlights] = useState<PreviousFlights>({});

  useEffect(() => {
    if (!flightData?.serialNumber) return;

    const serial = flightData.serialNumber as string;

    setPreviousFlights((old: PreviousFlights) => {
      const prev = old[serial];

      // Use heading from flightData if available
      if (typeof flightData.heading === 'number' && !isNaN(flightData.heading)) {
      //const fixedHeading = (360 - flightData.heading - 301 + 360) % 360;
      // const fixedHeading = flightData.heading -112;

        setRotations((r) => ({ ...r, [serial]: flightData.heading as number }));
      } else {
        // Fallback: calculate new bearing if drone moved, otherwise keep previous rotation
        const hasMoved = prev &&
          (Number(prev.latitude) !== Number(flightData.latitude) ||
           Number(prev.longitude) !== Number(flightData.longitude));

        if (hasMoved) {
          const newBearing = getBearing(
            { lat: Number(prev.latitude), lng: Number(prev.longitude) },
            { lat: Number(flightData.latitude), lng: Number(flightData.longitude) }
          );
        //  setRotations((r) => ({ ...r, [serial]: newBearing }));
        }
        // If no movement and no heading, keep previous rotation (already in state)
      }

      return {
        ...old,
        [serial]: {
          latitude: flightData.latitude?.toString() ?? '',
          longitude: flightData.longitude?.toString() ?? '',
        },
      };
    });
  }, [flightData]);

  return { rotations, previousFlights };
};

